const columns = {
    //NBA TEAM
    "g": "Game",
    "date": "Date",
    "is_home": "Home",
    "opp": "Opp",
    "is_win": "Win",
    "score_tm": "Team Score",
    "score_opp": "Opp Score",
    "is_ot": "OT",
    "team_fg": "Team FG",
    "team_fga": "Team FGA",
    "team_fg_pctg": "Team FG%",
    "team_3p": "Team 3P",
    "team_3pa": "Team 3PA",
    "team_3p_pctg": "Team 3P%",
    "team_2p": "Team 2P",
    "team_2pa": "Team 2PA",
    "team_2p_pctg": "Team 2P%",
    "team_efg_pctg": "Team eFG%",
    "team_ft": "Team FT",
    "team_fta": "Team FTA",
    "team_ft_pctg": "Team FT%",
    "team_orb": "Team ORB",
    "team_drb": "Team DRB",
    "team_trb": "Team TRB",
    "team_ast": "Team AST",
    "team_stl": "Team STL",
    "team_blk": "Team BLK",
    "team_tov": "Team TOV",
    "team_pf": "Team PF",
    "opponent_fg": "Opp FG",
    "opponent_fga": "Opp FGA",
    "opponent_fg_pctg": "Opp FG%",
    "opponent_3p": "Opp 3P",
    "opponent_3pa": "Opp 3PA",
    "opponent_3p_pctg": "Opp 3P%",
    "opponent_2p": "Opp 2P",
    "opponent_2pa": "Opp 2PA",
    "opponent_2p_pctg": "Opp 2P%",
    "opponent_efg_pctg": "Opp eFG%",
    "opponent_ft": "Opp FT",
    "opponent_fta": "Opp FTA",
    "opponent_ft_pctg": "Opp FT%",
    "opponent_orb": "Opp ORB",
    "opponent_drb": "Opp DRB",
    "opponent_trb": "Opp TRB",
    "opponent_ast": "Opp AST",
    "opponent_stl": "Opp STL",
    "opponent_blk": "Opp BLK",
    "opponent_tov": "Opp TOV",
    "opponent_pf": "Opp PF",
    //NBA PLAYER STATS
    "pts": "PTS",
    "3p": "3P",
    "3pm": "3PM",
    "trb": "TRB",
    "ast": "AST",
    "pts_rbs": "PTS+TRB",
    "pts_ast": "PTS+AST",
    "pts_rbs_ast": "PTS+TRB+AST",    
    //nba player props
    "player_points": "Points",
    "player_rebounds": "Rebounds",
    "player_assists": "Assists",
    "player_threes": "Three Pointers",
    "player_blocks": "Blocks",
    "player_points_assists": "Points + Assists",
    "player_points_rebounds": "Points + Rebounds",
    "player_points_rebounds_assists": "Points + Rebounds + Assists",
    "player_rebounds_assists": "Rebounds + Assists",
    //NHL TEAM STATS
    "games_played": "GP",
    "game_date": "Date",
    "opponent": "Opp",
    "goals_for": "GF",
    "goals_against": "GA",
    "team_shots_on_goal": "Team SOG",
    "team_pen_in_min": "Team PIM",
    "team_power_play_goals": "Team PPG",
    "team_power_play_opps": "Team PPGA",
    "team_short_handed_goals": "Team SHG",
    "opponent_shots_on_goal": "Opp SOG",
    "opponent_pen_in_min": "Opp PIM",
    "opponent_power_play_goals": "Opp PPG",
    "opponent_power_play_opps": "Opp PPGA",
    "opponent_short_handed_goals": "Opp SHG",
    "adv_5v5_cf": "Team CF",
    "adv_5v5_ca": "Team CA",
    "adv_5v5_cf_pctg": "Team CF%",
    "adv_5v5_ff": "Team FF",
    "adv_5v5_fa": "Team FA",
    "adv_5v5_ff_pctg": "Team FF%",
    "adv_5v5_o_zs_pctg": "Team OZS%",
    "adv_5v5_pdo": "Team PDO",
    //NHL PROPT STATs
    "player_power_play_points": "Power play points",
    "player_blocked_shots": "Blocked shots",
    "player_shots_on_goal": "Shots on goal",
    "player_goals": "Goals",
    "player_total_saves": "Total Saves",
    //MLB PROP STATS
    "batter_home_runs": "Batter home runs",
    "batter_first_home_run": "Batter first home run", 
    "batter_hits": "Batter hits",
    "batter_total_bases": "Batter total bases",
    "batter_rbis": "Batter RBIs",
    "batter_runs_scored": "Batter runs scored",
    "batter_hits_runs_rbis": "Batter hits + runs + RBIs",
    "batter_stolen_bases": "Batter stolen bases",
    "pitcher_strikeouts": "Pitcher strikeouts",
    "pitcher_record_a_win": "Pitcher to record a win",    
    
    "player_home_runs": "Batter home runs",    
    "player_first_home_run": "Batter first home run",
    "player_hits": "Batter hits",
    "player_total_bases": "Batter total bases",
    "player_rbis": "Batter RBIs",
    "player_runs_scored": "Batter runs scored",
    "player_hits_runs_rbis": "Batter hits + runs + RBIs",
    "player_stolen_bases": "Batter stolen bases",
    "player_strikeouts": "Pitcher strikeouts",
    "player_record_a_win": "Pitcher to record a win",    
    "pitcher_earned_runs": "Pitcher earned runs",
    "pitcher_outs": "Pitcher outs",
    //WNBA PLAYER STATS
    "assists": "AST",
    "blocks": "BLK",
    "defensive_rebounds": "DRB",
    "field_goals_attempted": "FGA",
    "field_goals_made": "FGM",
    "free_throws_attempted": "FTA",
    "free_throws_made": "FTM",
    "games_started": "GS",
    "location": "Loc",
    "minutes_played": "MP",
    "offensive_rebounds": "ORB",
    "opponent_short_name": "Opp",
    "personal_fouls": "PF",
    "points": "PTS",
    "result_margin": "Result",
    "season_year": "Year",
    "steals": "STL",
    "team_short_name": "Team",
    "three_pointers_attempted": "3PA",
    "three_pointers_made": "3PM",
    "total_rebounds": "TRB",
    "turnovers": "TOV",
    //wnba_game_logs
    // WNBA game log column display names (short string values)
    // Lowercased keys for WNBA game log column display names
    "opponent name": "Opp",
    "win_loss": "Result",
    "team_score": "TM Score",
    "opponent_score": "Opp Score",
    "team_field_goals_made": "FGM",
    "team_field_goals_attempted": "FGA",
    "team_field_goal_percent": "FG%",
    "team_3pt_field_goals_made": "3PM",
    "team_3pt_field_goals_attempted": "3PA",
    "team_3pt_field_goal_percent": "3P%",
    "team_free_throws_made": "FTM",
    "team_free_throws_attempted": "FTA",
    "team_free_throw_percent": "FT%",
    "team_offensive_rebounds": "ORB",
    "team_total_rebounds": "TRB",
    "team_assists": "AST",
    "team_steals": "STL",
    "team_blocks": "BLK",
    "team_turnovers": "TOV",
    "team_personal_fouls": "PF",
    "opponent_field_goals_made": "Opp FGM",
    "opponent_field_goals_attempted": "Opp FGA",
    "opponent_field_goal_percent": "Opp FG%",
    "opponent_3pt_field_goals_made": "Opp 3PM",
    "opponent_3pt_field_goals_attempted": "Opp 3PA",
    "opponent_3pt_field_goal_percent": "Opp 3P%",
    "opponent_free_throws_made": "Opp FTM",
    "opponent_free_throws_attempted": "Opp FTA",
    "opponent_free_throw_percent": "Opp FT%",
    "opponent_offensive_rebounds": "Opp ORB",
    "opponent_total_rebounds": "Opp TRB",
    "opponent_assists": "Opp AST",
    "opponent_steals": "Opp STL",
    "opponent_blocks": "Opp BLK",
    "opponent_turnovers": "Opp TOV",
    "opponent_personal_fouls": "Opp PF",
    "team": "Team",
    "year": "Year",
    "week": "Week",
    "day": "Day",
    "result": "Result",
    // NFL game log column display names (short string values)
    "opponent_team_short_name": "Opp",
    "overtime": "OT",
    "points_for": "PF",
    "points_against": "PA",
    "passing_yards": "Pass Yds",
    "opp_passing_yards": "Opp Pass Yds",
    "passing_tds": "Pass TD",
    "opp_passing_tds": "Opp Pass TD",
    "rushing_yards": "Rush Yds",
    "opp_rushing_yards": "Opp Rush Yds",
    "rushing_tds": "Rush TD",
    "opp_rushing_tds": "Opp Rush TD",
    "total_plays": "Plays",
    "opp_total_plays": "Opp Plays",
    "total_yards": "Yards",
    "opp_total_yards": "Opp Yards",
    "yards_per_play": "Yds/Play",
    "opp_yards_per_play": "Opp Yds/Play",
    "field_goals_made": "FGM",
    "opp_field_goals_made": "Opp FGM",
    "extra_points_made": "XPM",
    "opp_extra_points_made": "Opp XPM",
    "punts": "Punts",
    "opp_punts": "Opp Punts",
    "penalties": "Pen",
    "opp_penalties": "Opp Pen",
    "penalty_yards": "Pen Yds",
    "opp_penalty_yards": "Opp Pen Yds",
    "fumbles_lost": "Fum",
    "opp_fumbles_lost": "Opp Fum Lost",
    "interceptions_thrown": "INT",
    "opp_interceptions_thrown": "Opp INT",
    "total_turnovers": "TO",
    "opp_total_turnovers": "Opp TO",
    "time_of_possession": "TOP",
    "opp_time_of_possession": "Opp TOP",
    "player_id": "Player ID",
    "statspyder_player_id" : "Player ID",
    "position": "Position", 
    "game_number": "Game Number", 
    "games_started": "Games Started",
    // Organized player stat columns with descriptive display names
    "pass_completions": "Pass Comp",
    "pass_attempts": "Pass Att",
    "pass_completion_pct": "Comp %",
    "passing_yards_per_pass_attempt": "Yds/Att",
    "adjusted_passing_yards_per_pass_attempt": "Adj Yds/Att",
    "passer_rating": "Rating",
    "sacks_taken": "Sacks",
    "net_passing_yards": "Net Pass Yds",
    "rush_attempts": "Att",
    "yards_per_rush": "Y/A",
    "receptions_targeted": "Tgt",
    "receptions": "Rec",
    "receiving_yards": "Rec Yds",
    "receiving_tds": "Rec TD",
    "receiving_catch_pct": "C%",
    "receiving_yards_per_target": "Y/Tgt",
    "receiving_yards_per_reception": "Y/Rec",
    // Duplicates removed for clarity
    "field_goal_attempts_0_19": "FGA 0-19",
    "field_goals_made_0_19": "FGM 0-19",
    "field_goal_attempts_20_29": "FGA 20-29",
    "field_goals_made_20_29": "FGM 20-29",
    "field_goal_attempts_30_39": "FGA 30-39",
    "field_goals_made_30_39": "FGM 30-39",
    "field_goal_attempts_40_49": "FGA 40-49",
    "field_goals_made_40_49": "FGM 40-49",
    "field_goal_attempts_50_plus": "FGA 50+",
    "field_goals_made_50_plus": "FGM 50+",
    "field_goal_attempts": "FGA",
    "field_goals_made": "FGM",
    "field_goal_pct": "FG%",
    "extra_point_attempts": "XPA",
    "extra_points_made": "XPM",
    "extra_point_pct": "XP%",
    "kickoffs": "KO",
    "kickoff_yards": "KO Yds",
    "touchbacks": "TB",
    "touchback_pct": "TB%",
    "kickoff_avg": "KO Avg"
}

export const getColumnName = (column) => {
    return columns[column];
}

/**
 * Turns a prop market key (e.g. player_points) into the same display label
 * used in scouting report prop cards: configured name when present, else title case.
 */
export const formatPropMarketTypeLabel = (marketType) => {
    const configuredLabel = getColumnName(marketType);
    if (configuredLabel) {
        return configuredLabel;
    }

    return String(marketType || 'Unknown Market')
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};